import "core-js/modules/es.array.fill.js";
export var notificationPortalTokens = {
  paddingTop: 16,
  paddingRight: 16,
  paddingBottom: 20,
  paddingLeft: 16,
  titleMarginBottom: 8,
  contentMarginLeft: 8,
  closeIconMarginLeft: 16,
  borderRadius: 8,
  boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.2)",
  defaultVariant: "neutral",
  iconType: "stroke",
  variants: {
    neutral: {
      fontColor: function fontColor(_ref) {
        var color = _ref.color;
        return color.text.black.base;
      },
      iconColor: function iconColor(_ref2) {
        var color = _ref2.color;
        return color.fill.icon.base;
      },
      backgroundColor: function backgroundColor(_ref3) {
        var palette = _ref3.palette;
        return palette.neutralsBlack.hex5;
      }
    },
    success: {
      fontColor: function fontColor(_ref4) {
        var color = _ref4.color;
        return color.text.black.base;
      },
      iconColor: function iconColor(_ref5) {
        var color = _ref5.color;
        return color.fill.icon.base;
      },
      backgroundColor: function backgroundColor(_ref6) {
        var color = _ref6.color;
        return color.importance.success.light;
      }
    },
    attention: {
      fontColor: function fontColor(_ref7) {
        var color = _ref7.color;
        return color.text.black.base;
      },
      iconColor: function iconColor(_ref8) {
        var color = _ref8.color;
        return color.fill.icon.base;
      },
      backgroundColor: function backgroundColor(_ref9) {
        var color = _ref9.color;
        return color.importance.attention.light;
      }
    },
    danger: {
      fontColor: function fontColor(_ref10) {
        var color = _ref10.color;
        return color.text.black.base;
      },
      iconColor: function iconColor(_ref11) {
        var color = _ref11.color;
        return color.fill.icon.base;
      },
      backgroundColor: function backgroundColor(_ref12) {
        var color = _ref12.color;
        return color.importance.danger.light;
      }
    }
  }
};